import { render, staticRenderFns } from "./process-table-item.vue?vue&type=template&id=5df28370&scoped=true"
import script from "./process-table-item.vue?vue&type=script&lang=js"
export * from "./process-table-item.vue?vue&type=script&lang=js"
import style0 from "./process-table-item.vue?vue&type=style&index=0&id=5df28370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df28370",
  null
  
)

export default component.exports